/// <reference types="vite-plugin-pwa/react" />

import { useRegisterSW } from 'virtual:pwa-register/react'
import { logger } from '@pkg/shared/logger'
import { Button } from 'antd'
import type { ReactNode } from 'react'

export interface UpdateAvailableContainerProps {
  children: ReactNode
}

export const UpdateAvailableContainer = (props: UpdateAvailableContainerProps) => {
  const { children } = props
  const {
    offlineReady: [_offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(r) {
      logger.info(`SW Registered: ${r}`)
    },
    onRegisterError(err: unknown) {
      logger.error({ err }, 'SW registration error')
    },
  })

  const _close = () => {
    setOfflineReady(false)
    setNeedRefresh(false)
  }

  if (!needRefresh) {
    return children
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="text-lg font-semibold">Neue Aktualisierung verfügbar</div>
      <div className="text-sm text-gray-600">Eine neue Version von iCare ist verfügbar.</div>
      <Button type="primary" onClick={() => void updateServiceWorker(true)}>
        Aktualisieren
      </Button>
    </div>
  )
}
